import { render, staticRenderFns } from "./UserProfileAccount.vue?vue&type=template&id=7b6f3886&scoped=true"
import script from "./UserProfileAccount.vue?vue&type=script&lang=js"
export * from "./UserProfileAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f3886",
  null
  
)

export default component.exports